<template>
    <div class="sw__container">
        <div class="sw__title"><i class="fa fa-circle-o-notch fa-spin text-primary fa-fw mr-2" v-if="loading"></i> {{title}}</div>
        <div class="sw__actions">
            <button :disabled="loading || isDisabled" class="btn" @click="handleSwitchValue()" :class="{'btn-primary isActive': isChecked}">Sí</button>
            <button :disabled="loading || isDisabled" class="btn" @click="handleSwitchValue(true)" :class="{'btn-primary isActive': !isChecked}">No</button>
        </div>
    </div>
</template>
<script>
import Auth from "@/helpers/middleware";
import sysMsg from '@/helpers/system.message'
import migrationServices from "@/services/migration.services";

export default {
    name: "SwitchElement",
    props: ['title', 'switchValue', 'dealerIdentifier', 'serviceIdentifier', 'isDisabled', 'control', 'isCP'],
    data() {
        return {
            loading: false,
            user: Auth.getUser(),
            prevState: null
        }
    },
    computed: {
        isChecked() {
            return this.switchValue.status && this.switchValue.status === 'active'
        }

    },
    methods: {
        handleSwitchValue(removeService) {
            
            const dialog = this.isCP ? { text: "Esta acción no se puede revertir", type: "warning", title: '¿Migrar a Control Panel?' } : 
                                       { text: "¿Seguro que desea actualizar este servicio?", type: "", title: '' }

            sysMsg.getConfirm(dialog.text, dialog.type, dialog.title).then(result => {
                if(result.value) {
                    this.prevState = {...this.switchValue};
                    this.setDealerService(removeService);
                }
            });
        },
        setDealerService(removeService) {
            this.loading = true;
            migrationServices.cpApi.setDealerService(this.dealerIdentifier, this.serviceIdentifier, removeService).then(data => {
                this.$emit("update:switchValue", data);
                this.loading = false;
                sysMsg.getMessage('Servicio actualizado', 'success');

                // Si el servicio es Control Panel y se está realizando una activación, guardar en BDD Local
                    if((data && data.code ? data.code.toString().toUpperCase() : null)  === "CP" && data.status === 'active')
                        this.setLocalDealer();
                

            }).catch(error => {
                console.log('setDealerServices', error.message)
                this.$emit("update:switchValue", {...this.prevState});
                this.loading = false;
                sysMsg.getResponseMessage(error.response);
            });
        },
        setLocalDealer() {
            this.loading = true;
            sysMsg.getMessage('Procesando migración a CP, espere...', 'info');
            migrationServices.localApi.setDealerService(this.dealerIdentifier, this.user).then(data => {
                this.$emit("update:control", data);
                this.loading = false;
                sysMsg.getMessage('Dealer marcado para migrar a CP', 'success');

            }).catch(error => {
                console.log('setLocalDealer', error.message)
                this.loading = false;
                sysMsg.getResponseMessage(error.response);
            });
        },
    },

}
</script>
<style lang="scss" scoped>

.sw {
    &__container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media(max-width: 500px) {
            display: block;
        }
    }

    &__title {
        padding: 5px;
    }

    &__actions {
        padding: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn {
            border-radius: 3px;
            margin: 0;
            &:first-child {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
            &:last-child {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }

            &:not(.btn-primary) {
                border-color: rgb(241, 241, 241);
            }

            &.isActive {
                pointer-events: none;
            }

            &:disabled {
                opacity: .6;
                pointer-events: none;
            }
        }
    }
}

.switchElement {
    //margin-bottom: 10px;

    &.hasTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .switch-field {
            width: 100%;
            justify-content: flex-end;
            padding-right: 5px;
        }
    }
}
.switch-title {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
}
.switch-field {
	display: flex;
	overflow: hidden;
}

.switch-field input {
	position: absolute !important;
	clip: rect(0, 0, 0, 0);
	height: 1px;
	width: 1px;
	border: 0;
	overflow: hidden;
}

.switch-field label {
	background-color: #e4e4e4;
	color: rgba(0, 0, 0, 0.6);
	font-size: 14px;
	line-height: 1;
	text-align: center;
	padding: 8px 16px;
	margin-right: -1px;
    margin-bottom: 0;
	border: 1px solid rgba(0, 0, 0, 0.2);
	box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);
	transition: all 0.1s ease-in-out;
}

.switch-field label:hover {
	cursor: pointer;
}

.switch-field input:checked + label {
	background-color: #a5dc86;
	box-shadow: none;
}

.switch-field input:disabled + label {
    opacity: .6;
    pointer-events: none;
}

.switch-field label:first-of-type {
	border-radius: 4px 0 0 4px;
}

.switch-field label:last-of-type {
	border-radius: 0 4px 4px 0;
}
</style>